export default __webpack_public_path__ + "static/media/super_prev_icon.4328f91c.svg";